// CHG-131 Step 5: /me/profile 조회·수정·아바타 훅
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchMyProfile,
  updateMyProfile,
  uploadAvatar,
  deleteAvatar,
  fetchPublicProfile,
  type UpdateProfileInput,
} from '../services/userProfileService';

export const MY_PROFILE_QUERY_KEY = ['me', 'profile'] as const;

export function useMyProfile() {
  return useQuery({
    queryKey: MY_PROFILE_QUERY_KEY,
    queryFn: fetchMyProfile,
    staleTime: 60_000,
  });
}

export function useUpdateMyProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateProfileInput) => updateMyProfile(input),
    onSuccess: (data) => {
      qc.setQueryData(MY_PROFILE_QUERY_KEY, data);
      // GNB/사이드바 아바타 등 다른 곳도 무효화
      qc.invalidateQueries({ queryKey: ['user-profile-public', data.userId] });
    },
  });
}

export function useUploadAvatar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadAvatar(file),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: MY_PROFILE_QUERY_KEY });
    },
  });
}

export function useDeleteAvatar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => deleteAvatar(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: MY_PROFILE_QUERY_KEY });
    },
  });
}

export function usePublicProfile(userId: string | null | undefined) {
  return useQuery({
    queryKey: ['user-profile-public', userId],
    queryFn: () => fetchPublicProfile(userId!),
    enabled: !!userId,
    staleTime: 30_000,
  });
}
